module.exports = __webpack_public_path__ + "img/PLUS.82adbe79.svg";